import Vue from "vue";

import {
  getValutes,
  queryPaginationCrossRates,
  addCrossRate,
  deleteCrossRate,
  editCrossRate,
  getValuteCities
} from "@/api";
//
const defaultCrossRate = {
  _id: false,
  from: { _id: null },
  to: { _id: null },
  city: { _id: null },
  isActive: true,
  makeTopIsActive: false,
  makeTopLimitMult: 1.1,
  makeTopStep: 0,
  makeTopIgnoredExchangeNames: 0
};
//
const allTypes = [
  "isDisabled",
  "makeTopIsActive",
  "makePlaceIsActive",
  "isFixed"
];
export default {
  namespaced: true,

  state: {
    crossRates: [],
    valutes: [],
    valuteCities: [],
    from: null,
    to: null,
    city: null,
    isActive: null,
    showTypes: [],
    isFiltered: false,
    crossRateInModal: null,
    page: 1,
    limit: 10,
    sort: "_id",
    dialogVisible: false,
    loading: true
  },

  mutations: {
    setValutes(state, valutes) {
      state.valutes = valutes;
    },
    setCrossRates(state, crossRates) {
      state.crossRates = crossRates;
    },
    setValuteCities(state, valuteCities) {
      state.valuteCities = valuteCities;
    },
    setFrom(state, from) {
      state.from = from;
    },
    setTo(state, to) {
      state.to = to;
    },
    setCity(state, city) {
      state.city = city;
    },
    setIsActive(state, isActive) {
      state.isActive = isActive;
    },
    setShowTypes(state, showTypes) {
      state.showTypes = showTypes;
    },
    setCrossRateInModal(state, crossRateInModal) {
      state.crossRateInModal = crossRateInModal;

      if (!state.crossRateInModal.city) {
        state.crossRateInModal.city = { _id: null };
      }
    },
    setIsFiltered(state, isFiltered) {
      state.isFiltered = isFiltered;
    },
    setPage(state, page) {
      state.page = page;
    },
    setLimit(state, limit) {
      state.limit = limit;
    },
    setSort(state, sort) {
      state.sort = sort;
    },
    setDialogVisible(state, dialogVisible) {
      state.dialogVisible = dialogVisible;
    },
    setLoading(state, loading) {
      state.loading = loading;
    }
  },

  actions: {
    async filterQueryBuilder(store) {
      if (
        !store.state.from &&
        !store.state.to &&
        !store.state.city &&
        !store.state.isActive &&
        (!store.state.showTypes.length ||
          store.state.showTypes.length === allTypes.length)
      ) {
        store.commit("setIsFiltered", false);
        return {};
      }

      const queryBuilders = [
        {
          state: "from",
          builder: () => {
            return {
              from: store.state.from
            };
          }
        },
        {
          state: "to",
          builder: () => {
            return {
              to: store.state.to
            };
          }
        },
        {
          state: "city",
          builder: () => {
            return {
              city: store.state.city
            };
          }
        },
        {
          state: "isActive",
          builder: () => {
            return {
              isActive: store.state.isActive
            };
          }
        },
        {
          state: "showTypes",
          builder: () => {
            if (!store.state.showTypes.length) return;
            const ret = store.state.showTypes.map(v => {
              return { [v]: true };
            });
            return { $or: ret };
          }
        }
      ];

      const query = {
        $and: queryBuilders
          .filter(b => !!store.state[b.state])
          .map(b => b.builder())
          .filter(b => !!b)
      };

      store.commit("setIsFiltered", true);

      return query;
    },

    async queryPaginationCrossRates(store) {
      store.commit("setLoading", true);
      const query = await store.dispatch("filterQueryBuilder");
      console.log(query);
      const response = await queryPaginationCrossRates({
        page: store.state.page,
        limit: store.state.limit,
        sort: store.state.sort,
        query
      });
      //
      const crossRates = response.data.result;
      //
      store.commit("setCrossRates", crossRates);
      //
      store.commit("setLoading", false);
      return response;
    },

    getValutes(store) {
      return getValutes().then(response => {
        store.commit("setValutes", response.data.result);
        //
        return response;
      });
    },
    getValuteCities(store) {
      return getValuteCities({ pagination: false }).then(response => {
        store.commit("setValuteCities", response.data.result.docs);
        //
        return response;
      });
    },

    async addCrossRate(store, crossRate) {
      return await addCrossRate(crossRate);
    },

    deleteCrossRate(store, id) {
      return deleteCrossRate(id).then(response => {
        store.dispatch("queryPaginationCrossRates");
        //
        return response;
      });
    },

    async editCrossRate(store, data) {
      return await editCrossRate(data);
    },

    performSearch(store, payload) {
      if (store.state.from !== "") {
        // todo ??
        store.commit("setTo", null);
        store.commit("setTo", null);
        store.commit("setIsActive", null);
        store.commit("setPage", 1);
      }

      store.dispatch("queryPaginationCrossRates");
    },

    changeShowTypes(store, payload) {
      if (payload.showTypes !== undefined) {
        store.commit("setShowTypes", payload.showTypes);
        store.commit("setPage", 1);
        store.dispatch("queryPaginationCrossRates");
      }
    },

    changeFrom(store, payload) {
      if (payload.from !== undefined) {
        store.commit("setFrom", payload.from);
        store.commit("setPage", 1);
        store.dispatch("queryPaginationCrossRates");
      }
    },

    changeTo(store, payload) {
      if (payload.to !== undefined) {
        store.commit("setTo", payload.to);
        store.commit("setPage", 1);
        store.dispatch("queryPaginationCrossRates");
      }
    },

    changeCity(store, payload) {
      if (payload.city !== undefined) {
        store.commit("setCity", payload.city);
        store.commit("setPage", 1);
        store.dispatch("queryPaginationCrossRates");
      }
    },

    changeIsActive(store, payload) {
      if (payload.isActive !== undefined) {
        store.commit("setIsActive", payload.isActive);
        store.commit("setPage", 1);
        store.dispatch("queryPaginationCrossRates");
      }
    },

    changeLoading(store, payload) {
      if (payload.loading !== undefined) {
        store.commit("setLoading", payload.loading);
      }
    },

    changeDataInModal(store, payload) {
      if (payload.crossRateInModal !== undefined) {
        store.commit("setCrossRateInModal", payload.crossRateInModal);
      } else {
        store.commit("setCrossRateInModal", { ...defaultCrossRate });
      }
    },

    changeDialogVisible(store, payload) {
      if (payload.dialogVisible !== undefined) {
        store.commit("setDialogVisible", payload.dialogVisible);
      }
    },

    async resetSearch(store, payload) {
      store.commit("setFrom", null);
      store.commit("setTo", null);
      store.commit("setCity", null);
      store.commit("setIsActive", null);
      store.commit("setShowTypes", []);
      await store.dispatch("queryPaginationCrossRates");
    },

    async changeLimit(store, payload) {
      if (payload.limit !== undefined) {
        store.commit("setLimit", payload.limit);
        await store.dispatch("queryPaginationCrossRates");
      }
    },

    async changeSorting(store, payload) {
      if (payload.sort !== undefined) {
        store.commit("setSort", payload.sort);
        await store.dispatch("queryPaginationCrossRates");
      }
    },

    async goToPage(store, payload) {
      if (
        payload.page &&
        store.state.crossRates.totalPages &&
        store.state.crossRates.totalPages >= payload.page
      ) {
        store.commit("setPage", payload.page);
        await store.dispatch("queryPaginationCrossRates");
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/crossRate.js